import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams, Navigate } from "react-router-dom";
import { setTheme, setUser } from '../redux/actions';
import loader from '../assets/loader.mp4';
import loaderWeb from '../assets/loader_web.mp4';
import { getAuthUrl, getBaseUrl } from '../config/auth';
import { authLogger } from '../utils/logger';

const { PROD } = import.meta.env;

function GuestRoute({ setTheme, setUser, redirectPath = '/' }) {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [redirectToSSO, setRedirectToSSO] = useState(false);
    const [redirectToDashboard, setRedirectToDashboard] = useState(false);
    const [authenticationCompleted, setAuthenticationCompleted] = useState(false);

    const loaderInstance = useRef(null);
    const loaderWebInstance = useRef(null);

    useEffect(() => {
        const handleAuthentication = async () => {
            const code = searchParams.get('code');
            if (code) {
                try {
                    const redirectUri = `${window.location.origin}/login`;
                    
                    const response = await fetch('/nodeapi/auth/token', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ code, redirectUri }),
                    });

                    if (!response.ok) {
                        throw new Error('Failed to exchange code for token');
                    }

                    const data = await response.json();

                    localStorage.setItem('token', data.data.accessToken);
                    localStorage.setItem('theme', 'light');
                    localStorage.setItem('user', JSON.stringify(data.data.user));

                    setTheme({ theme: 'light' });
                    setUser({ user: data.data.user });
                    
                    // Log the successful login event
                    const username = data.data.user?.preferred_username || data.data.user?.email || 'unknown';
                    authLogger.logLogin(username);

                    setRedirectToDashboard(true);
                } catch (error) {
                    console.error('Error handling authentication:', error);
                    setRedirectToSSO(true);
                }
            } else {
                setRedirectToSSO(true);
            }

            setLoading(false);
            setAuthenticationCompleted(true);
        };

        handleAuthentication();
    }, [searchParams, setTheme, setUser]);

    useEffect(() => {
        if (loaderInstance.current) {
            loaderInstance.current.play();
        }
        if (loaderWebInstance.current) {
            loaderWebInstance.current.play();
        }
        document.body.classList.add('overflow-hidden');
    }, []);

    const handleEnded = async () => {
        document.body.classList.remove('overflow-hidden');
        
        // Delay to ensure authentication process has completed
        while (!authenticationCompleted) {
            await new Promise(resolve => setTimeout(resolve, 500));
        }

        if (redirectToSSO) {
            window.location.href = getAuthUrl();
        } else if (redirectToDashboard) {
            navigate(redirectPath);
        }
    };


    if (redirectToDashboard) {
        return <Navigate to={redirectPath} replace />;
    }

    if (redirectToSSO) {
        window.location.href = getAuthUrl();
        return null;
    }

    return null;

}

export default connect(
    null,
    { setTheme, setUser }
)(GuestRoute);